import React from 'react';
import { ReactComponent as LocationSvg } from '../../../../assets/icons/location.svg';
import { Button, Flex, Typography, ConfigProvider } from 'antd';
import { HYPHEN } from '../../../../utilities/constants';
import PropTypes from 'prop-types';

const { Text } = Typography;
const AnomalyCard = ({ data, onTripDetailClick }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            fontSize: '0.875rem',
          },
        },
      }}
    >
      <Flex vertical gap={8}>
        <Text strong>
          {data?.trip_id || HYPHEN} | {data?.device_id || HYPHEN}
        </Text>
        <Flex gap={10} justify="flex-end">
          <Button
            style={{ height: '48px', width: '48px' }}
            icon={<LocationSvg />}
            onClick={() =>
              onTripDetailClick(
                data,
                data?.trip_id,
                data?.device_id,
                data?.anomlay_id
              )
            }
          />
        </Flex>
      </Flex>
    </ConfigProvider>
  );
};

AnomalyCard.propTypes = {
  data: PropTypes.object,
  onTripDetailClick: PropTypes.func.isRequired,
};

export default React.memo(AnomalyCard);
